import React from 'react';
import MaterialTable from "material-table";
import TransFR from "../../../../../i18n/translations/fr/translates.json";
import TransEN from "../../../../../i18n/translations/fr/translates.json";
import {useTranslation} from "react-i18next";
function FieldTable(props) {
    const { useState } = React;
    const {tableProps,columns,data,setData,...otherProps} = props;
    const {t,i18n} = useTranslation();
    const language = i18n.language;

    return (
        <MaterialTable
            title=""
            columns={columns.map((column)=>{
                if (!!column.isTranslatable){
                    column.title = t(column.title);
                }
                return column;
            })}
            data={data}
            editable={{
                onRowAdd: newData =>
                    new Promise((resolve, reject) => {
                        setTimeout(() => {
                            console.log(setData);
                            setData([...data, newData]);

                            resolve();
                        }, 1000)
                    }),
                onRowUpdate: (newData, oldData) =>
                    new Promise((resolve, reject) => {
                        setTimeout(() => {
                            const dataUpdate = [...data];
                            const index = oldData.tableData.id;
                            dataUpdate[index] = newData;
                            setData([...dataUpdate]);

                            resolve();
                        }, 1000)
                    }),
                onRowDelete: oldData =>
                    new Promise((resolve, reject) => {
                        console.log(setData);
                        setTimeout(() => {
                            const dataDelete = [...data];
                            const index = oldData.tableData.id;
                            dataDelete.splice(index, 1);
                            setData([...dataDelete]);

                            resolve()
                        }, 1000)
                    }),
            }}
            localization={language === "fr" ? TransFR.material_table:TransEN.material_table}
            {...tableProps}
        />
    )
}

export default FieldTable;